var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mini list-container"},[_c('div',{staticClass:"mini list-grid"},[_c('h6',{staticClass:"list-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }